import { toSafeObjectOrNull as toObject, toSafeString } from '@shared/utils';

const getInteractionRunId = (event = {}) => {
  const payload = toObject(event?.payload) || {};
  const interactionPayload = toObject(payload?.interaction) || {};
  const approvalPayload = toObject(payload?.approval) || toObject(interactionPayload?.approval) || {};

  return toSafeString(event?.runId || payload?.runId || interactionPayload?.runId || approvalPayload?.runId) || null;
};

export default getInteractionRunId;
